import { defineComponent as _defineComponent } from 'vue'
import { Carousel, Slide, Navigation } from "vue3-carousel";
  import { computed, ref } from "vue";
  import "vue3-carousel/dist/carousel.css";
  import BuilderLightboxImages from "./BuilderLightboxImages.vue";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomizeHouseSlider',
  props: {
    sliderImages: {
      type: Array,
      required: true,
    },
    showArrows: {
      type: Boolean,
      default: true,
    },
    isReviewQuote: {
      type: Boolean,
      default: false,
    },
    isBuilderQuoteView: {
      type: Boolean,
      required: false,
    },
    zoomOnSelect: {
      type: Boolean,
      default: true,
    },
    wrapAround: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onSelectImage"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const getSliderNavigation = computed(
    () => props.sliderImages.length > 1 && props.showArrows
  );
  const props = __props;
  const emits = __emit;
  const isImageModalOpen = ref(false);
  const selectedImageUrl = ref("");
  const zoom = ref(1);

  const openImageModal = (imageUrl: string) => {
    selectedImageUrl.value = imageUrl;
    isImageModalOpen.value = true;
  };

  const onSelectImage = (imageUrl: string) => {
    if (props.zoomOnSelect) {
      openImageModal(imageUrl);
    }

    emits("onSelectImage", imageUrl);
  };

  const closeImageModal = () => {
    isImageModalOpen.value = false;
    zoom.value = 1;
  };

  const updateZoom = (value: number) => {
    const newZoom = zoom.value + value;

    if (newZoom >= 1 && newZoom <= 2.6) {
      zoom.value = newZoom;
    }
  };

const __returned__ = { getSliderNavigation, props, emits, isImageModalOpen, selectedImageUrl, zoom, openImageModal, onSelectImage, closeImageModal, updateZoom, get Carousel() { return Carousel }, get Slide() { return Slide }, get Navigation() { return Navigation }, computed, ref, BuilderLightboxImages }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})